import { CCardFooter } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarCardFooter = (props) => {
  const { children } = props
  return <CCardFooter {...props}>{children}</CCardFooter>
}

export { ConfiaCarCardFooter }
